import script from "./ShareModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShareModal.vue?vue&type=script&setup=true&lang=ts"

import "./ShareModal.vue?vue&type=style&index=0&id=2173043a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2173043a"]])

export default __exports__